<fuse-alert
  [appearance]="'border'"
  [type]="types[toastPackage.toastType] || 'basic'"
  [dismissible]="true"
  (dismissedChanged)="remove()"
  [ngClass]="[types[toastPackage.toastType] || 'basic']"
>
  @let options = toastPackage.config;
  @let payload = options.payload;
  @if (title) {
    <div fuseAlertTitle>{{ title }}</div>
  }
  <div>
    <div
      class=""
      [innerHTML]="
        !payload?.notUseTranslate ? (message | transloco: payload) : message
      "
    ></div>
    @if (options.progressBar) {
      <div
        class="toast-progress opacity-100"
        [style.width]="width() + '%'"
      ></div>
    }
  </div>
</fuse-alert>
